<template>
  <div class="containerdiv">
    <div class="left-bottom-sign"></div>
    <!-- #ifdef MP -->
    <div class="back-btn yticon icon-zuojiantou-up" @click="navBack"></div>
    <!-- #endif -->
    <div class="right-top-sign"></div>
    <!-- 设置白色背景防止软键盘把下部绝对定位元素顶上来盖住输入框等 -->
    <div class="wrapper">
      <div class="left-top-sign">{{type}}</div>
      <div class="welcome">{{type=='login'?'欢迎回来':type=='regist'?'欢迎加入':'找回密码'}}！</div>
      <div v-if="type=='login'&&loginType=='password'" class="input-content">
        <div class="input-item">
          <span class="tit">手机号码</span>
          <input
            type="number"
            :value="mobile"
            placeholder="请输入手机号码"
            maxlength="11"
            data-key="mobile"
            @input="inputChange"
          />
        </div>
        <div class="input-item">
          <span class="tit">密码</span>
          <input
            type="mobile"
            :value="password"
            placeholder="8-18位不含特殊字符的数字、字母组合"
            placeholder-class="input-empty"
            maxlength="20"
            password
            data-key="password"
            @input="inputChange"
            @confirm="passwrodLogin"
          />
        </div>
      </div>
      <div v-if="type=='login'&&loginType=='code'" class="input-content">
        <div class="input-item">
          <span class="tit">手机号码</span>
          <input
            type="number"
            :value="mobile"
            placeholder="请输入手机号码"
            maxlength="11"
            data-key="mobile"
            @input="inputChange"
          />
        </div>
        <div class="input-item">
          <span class="tit">验证码</span>
          <div class="d-flex flex-row w-100">
            <input
              class="flex-1"
              type="mobile"
              :value="loginCode"
              placeholder="请输入6位验证码"
              placeholder-class="input-empty"
              maxlength="6"
              data-key="loginCode"
              @input="inputChange"
              @confirm="codeLogin"
            />
            <div
              class="get-code flex-center text-nowrap"
              @click="getCode"
            >{{codeTime!=60?codeTime+'秒后重新获取':'获取验证码'}}</div>
          </div>
        </div>
      </div>
      <div v-if="type=='regist'" class="input-content">
        <div class="input-item">
          <span class="tit">手机号码</span>
          <input
            type="number"
            :value="mobile"
            placeholder="请输入手机号码"
            maxlength="11"
            data-key="mobile"
            @input="inputChange"
          />
        </div>
        <div class="input-item">
          <span class="tit">密码</span>
          <input
            type="mobile"
            :value="registerPassword"
            placeholder="8-18位不含特殊字符的数字、字母组合"
            placeholder-class="input-empty"
            maxlength="20"
            password
            data-key="registerPassword"
            @input="inputChange"
          />
        </div>
        <div class="input-item">
          <span class="tit">验证码</span>
          <div class="d-flex flex-row w-100">
            <input
              class="flex-1"
              type="mobile"
              :value="registerCode"
              placeholder="请输入6位验证码"
              placeholder-class="input-empty"
              maxlength="6"
              data-key="registerCode"
              @input="inputChange"
              @confirm="register"
            />
            <div
              class="get-code flex-center text-nowrap"
              @click="getCode"
            >{{codeTime!=60?codeTime+'秒后重新获取':'获取验证码'}}</div>
          </div>
        </div>
      </div>
      <div v-if="type=='forgot'" class="input-content">
        <div class="input-item">
          <span class="tit">手机号码</span>
          <input
            type="number"
            :value="mobile"
            placeholder="请输入手机号码"
            maxlength="11"
            data-key="mobile"
            @input="inputChange"
          />
        </div>
        <div class="input-item">
          <span class="tit">验证码</span>
          <div class="d-flex flex-row w-100">
            <input
              class="flex-1"
              type="mobile"
              :value="forgotCode"
              placeholder="请输入6位验证码"
              placeholder-class="input-empty"
              maxlength="6"
              data-key="forgotCode"
              @input="inputChange"
            />
            <div
              class="get-code flex-center text-nowrap"
              @click="getCode"
            >{{codeTime!=60?codeTime+'秒后重新获取':'获取验证码'}}</div>
          </div>
        </div>
        <div class="input-item">
          <span class="tit">密码</span>
          <input
            type="mobile"
            :value="forgotPassword"
            placeholder="8-18位不含特殊字符的数字、字母组合"
            placeholder-class="input-empty"
            maxlength="20"
            password
            data-key="forgotPassword"
            @input="inputChange"
            @confirm="forgot"
          />
        </div>
      </div>
      <div
        v-if="type=='login'&&loginType=='password'"
        class="confirm-btn"
        @click="passwrodLogin"
        :disabled="logining"
      >登录</div>
      <div
        v-if="type=='login'&&loginType=='code'"
        class="confirm-btn"
        @click="codeLogin"
        :disabled="logining"
      >登录</div>
      <div v-if="type=='regist'" class="confirm-btn" @click="register" :disabled="logining">注册</div>
      <div v-if="type=='forgot'" class="confirm-btn" @click="forgot" :disabled="logining">找回密码</div>
      <div class="d-flex flex-row justify-content-around">
        <div
          v-if="type=='login'&&loginType=='password'"
          class="forget-section"
          @click="toCodeLogin"
        >验证码登录</div>
        <div
          v-if="type=='login'&&loginType=='code'"
          class="forget-section"
          @click="toPasswordLogin"
        >密码登录</div>
        <div v-if="type=='login'" class="forget-section" @click="toForgot">忘记密码?</div>
        <div v-if="type=='forgot'" class="forget-section" @click="toCodeLogin">验证码登录</div>
        <div v-if="type=='forgot'" class="forget-section" @click="toPasswordLogin">密码登录</div>
      </div>
    </div>
    <div class="register-section">
      {{type=='regist'?'已有账号?':'还没有账号?'}}
      <span
        v-if="type=='login'||type=='forgot'"
        @click="toRegist"
      >马上注册</span>
      <span v-if="type=='regist'" @click="toLogin">去登录</span>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex';

export default {
  data () {
    return {
      type: 'login',
      loginType: 'password',
      mobile: '',
      password: '',
      logining: false,
      registerPassword: '',
      forgotPassword: '',
      loginCode: '',
      registerCode: '',
      forgotCode: '',
      codeTime: 60
    }
  },
  computed: {
    ...mapState(['openId'])
  },
  methods: {
    ...mapMutations(['login']),
    inputChange (e) {
      const key = e.currentTarget.dataset.key;
      this[key] = e.detail.value;
    },
    navBack () {
      this.$router.go(-1)
    },
    toRegist () {
      this.type = 'regist'
    },
    toLogin () {
      this.type = 'login'
    },
    toPasswordLogin () {
      this.type = 'login'
      this.loginType = 'password'
    },
    toCodeLogin () {
      this.type = 'login'
      this.loginType = 'code'
    },
    toForgot () {
      this.type = 'forgot'
    },
    passwrodLogin () {
      let { mobile, password, openId } = this
      let isMini = false
      // #ifdef MP
      isMini = true
      // #endif
      this.logining = true
      this.$http.request(this.$http.pathMap.login, 'post', { username: mobile, password, openid: openId, isMini }).then(res => {
        this.logining = false
        localStorage.setItem('token', res.data)
        this.$toast('登录成功')
        // this.getUserInfo()
        this.login({})
      }).catch(err => {
        this.logining = false
      })
    },
    codeLogin () {
      let { mobile, loginCode, openId } = this
      let isMini = false
      // #ifdef MP
      isMini = true
      // #endif
      this.logining = true
      this.$http.request(this.$http.pathMap.loginCode, 'post', { phone: mobile, verifyCode: loginCode, openid: openId, isMini }).then(res => {
        this.logining = false
        localStorage.setItem('token', res.data)
        this.$toast('登录成功')
        this.getUserInfo()
      }).catch(err => {
        this.logining = false
      })
    },
    register () {
      let { mobile, registerPassword, registerCode, openId } = this
      let isMini = false
      // #ifdef MP
      isMini = true
      // #endif
      this.logining = true
      this.$http.request(this.$http.pathMap.register, 'post', { phone: mobile, password: registerPassword, verifyCode: registerCode, openid: openId, isMini }).then(res => {
        this.$toast('注册成功')
        this.password = registerPassword
        this.passwrodLogin()
        this.logining = false
      }).catch(err => {
        this.logining = false
      })
    },
    forgot () {
      let { mobile, forgotPassword, forgotCode } = this
      this.logining = true
      this.$http.request(this.$http.pathMap.retrievePwd, 'post', { phone: mobile, password: forgotPassword, verifyCode: forgotCode }).then(res => {
        this.logining = false
        this.$toast('密码找回成功,请重新登录')
        this.toPasswordLogin()
      }).catch(err => {
        this.logining = false
      })
    },
    getUserInfo () {
      this.$http.request(this.$http.pathMap.userInfo, 'post').then(res => {
        this.login(res.data)
        this.navBack()
      })
    },
    getCode () {
      if (this.codeTime != 60) {
        return
      }
      let that = this
      let { mobile } = this
      this.$http.request(this.$http.pathMap.sendCode, 'get', { phone: mobile }).then(res => {
        this.$toast('验证码发送成功')
        let interval = setInterval(() => {
          if (that.codeTime > 1) {
            that.codeTime -= 1
          } else {
            that.codeTime = 60
            clearInterval(interval)
          }
        }, 1000)
      })
    },
  },

}
</script>

<style lang='scss' scoped>
page {
  background: #fff;
}
.containerdiv {
  padding-top: 85px;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #fff;
}
.wrapper {
  position: relative;
  z-index: 90;
  /* background: #fff; */
  padding-bottom: 20px;
}
.back-btn {
  position: absolute;
  left: 20px;
  z-index: 9999;
  padding-top: var(--status-bar-height);
  top: 20px;
  font-size: 20px;
  color: $font-color-dark;
}
.left-top-sign {
  font-size: 60px;
  color: $page-color-base;
  position: relative;
}
.right-top-sign {
  position: absolute;
  top: 40px;
  right: -15px;
  z-index: 95;
  &:before,
  &:after {
    display: block;
    content: "";
    width: 200px;
    height: 40px;
    background: #b4f3e2;
  }
  &:before {
    transform: rotate(50deg);
    border-radius: 0 50px 0 0;
  }
  &:after {
    position: absolute;
    right: -99px;
    top: 0;
    transform: rotate(-50deg);
    border-radius: 50px 0 0 0;
    /* background: pink; */
  }
}
.left-bottom-sign {
  position: absolute;
  left: -135px;
  bottom: -160px;
  border: 50px solid #d0d1fd;
  border-radius: 50%;
  padding: 90px;
}
.welcome {
  position: relative;
  left: 25px;
  top: -45px;
  font-size: 23px;
  color: #555;
  text-shadow: 1px 0px 1px rgba(0, 0, 0, 0.3);
}
.input-content {
  padding: 0 30px;
}
.input-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 15px;
  background: $page-color-light;
  height: 60px;
  border-radius: 4px;
  margin-bottom: 25px;
  &:last-child {
    margin-bottom: 0;
  }
  .tit {
    height: 25px;
    line-height: 28px;
    font-size: $uni-font-size-sm + 1px;
    color: $font-color-base;
  }
  input {
    height: 30px;
    font-size: $uni-font-size-base + 1px;
    color: $font-color-dark;
    width: 100%;
  }
}
.get-code {
  border: 1px $font-color-spec solid;
  border-radius: 25px;
  color: $font-color-spec;
  font-size: $uni-font-size-sm + 1px;
  padding-left: 5px;
  padding-right: 5px;
}
.confirm-btn {
  width: 315px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  border-radius: 50px;
  margin: 35px auto;
  background: var(--theme-font-color);
  color: white;
  font-size: $uni-font-size-lg;
  &:after {
    border-radius: 100px;
  }
}
.forget-section {
  font-size: $uni-font-size-sm + 1px;
  color: $font-color-spec;
  text-align: center;
  margin-top: 20px;
}
.register-section {
  position: absolute;
  left: 0;
  bottom: 25px;
  width: 100%;
  font-size: $uni-font-size-sm + 1px;
  color: $font-color-base;
  text-align: center;
  text {
    color: $font-color-spec;
    margin-left: 5px;
  }
}
</style>
